import ScaleContainer from "./ScaleContainer";

export default ScaleContainer;
